import React from 'react'
import { Datagrid, List, TextField, FunctionField, DateField, TopToolbar } from 'ra-ui-materialui'
import { makeStyles } from '@material-ui/core'
import ColoredLeadPropertyStatusField from '../../../../components/ColoredLeadPropertyStatusField'
import CreateMeetingButton from './createMeetingButton'
import VisitDeleteButton from '../../../../components/VisitDeleteButton'
import VisitEditButton from '../../../../components/VisitEditButton'
import VisitFeedbackButton from '../../../../components/VisitFeedbackButton'
import { Box } from '@mui/system'
import { Typography } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import FeedbackTooltip from './feedBackTooltip'

const ListVisits = (props) => {
  const useStyles = makeStyles({
    rowCell: {
      maxWidth: '140px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      padding: '10px',
      '& span': {
        fontSize: '0.8rem',
      },
    },
  })

  const classes = useStyles()
  const leadProperty = props.record

  const VisitActions = ({ record }) => {
    return (
      <TopToolbar>
        <CreateMeetingButton leadProperty={record} />
      </TopToolbar>
    )
  }

  const Empty = (props) => {
    return (
      <Box textAlign="center" m={2}>
        <Typography variant="h5" paragraph>
          <InfoIcon /> No inspections available
        </Typography>
        <CreateMeetingButton {...props} leadProperty={leadProperty} />
      </Box>
    )
  }

  return (
    <>
      <List
        {...props}
        resource="visits"
        filterDefaultValues={{ property_id: leadProperty.property_id }}
        actions={<VisitActions {...props} />}
        bulkActionButtons={false}
        empty={<Empty {...props} />}
      >
        <Datagrid classes={{ rowCell: classes.rowCell }} optimized>
          <TextField label="Id" source="id" sortable={false} />
          <TextField source="subject" />
          <TextField source="description" />
          <DateField label="Datetime" source="start_date_time" sortable={false} />
          <FunctionField
            label="Status"
            source="status"
            sortable={false}
            render={(record, source) => <ColoredLeadPropertyStatusField record={{ ...record }} source={source} />}
          />
          <FunctionField
            label="Feedback"
            render={(record) =>
              record.outcome ? <FeedbackTooltip record={record} /> : <VisitFeedbackButton {...props} record={record} />
            }
          />

          <VisitEditButton basePath="/visits" />
          <VisitDeleteButton basePath="/visits" redirect={`/leadProperties/` + leadProperty.id} />
        </Datagrid>
      </List>
    </>
  )
}

export default ListVisits
